import { Navigate, Outlet, useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export default function PrivateRoute() {
    const isLoggedIn = useAuth();
    return isLoggedIn ? <Outlet /> : <Navigate to="/" />;
}
